// Presentation layer only — data/search/refresh come from useMarketAnalysis.
// DOM mirrors the reference market-analysis page: outer .market-analysis-container
// wraps per-event .market-analysis-container (title link + date, then
// .market-analysis-content > row row5 > col-lg-4 > .market-analysis-content-detail
// > table with th colspan=2 = market name).
import { Link } from 'react-router-dom'
import Layout from '../../components/Layout'
import { useMarketAnalysis } from '../../hooks/useMarketAnalysis'
import loaderGif from '../../assets/loader.gif'
import './style.css'

// Reference panel jaisa: 2 decimal + thousand separator —
// "-1487.5" → "-1,487.50", "175" → "175.00"
function fmtVal(v) {
  const n = parseFloat(v)
  if (Number.isNaN(n)) return String(v ?? '')
  return n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

// rows ko title ke teams ke order me lagao: team1, team2, phir baaki, The Draw last.
// (API order alag aata hai — reference home/away/draw dikhata hai)
function orderRows(rows, title) {
  const teams = String(title || '').split(/\s+v\s+|\s+vs\s+/i).map((t) => t.trim().toLowerCase())
  const rank = (label) => {
    const l = String(label || '').toLowerCase()
    if (teams[0] && l === teams[0]) return 0
    if (teams[1] && l === teams[1]) return 1
    if (l === 'the draw' || l === 'draw') return 3
    return 2
  }
  return [...rows].sort((a, b) => rank(a.label) - rank(b.label))
}

function fmtDate(d) {
  if (!d) return ''
  const dt = new Date(d)
  if (Number.isNaN(dt.getTime())) return String(d)
  const p = (n) => String(n).padStart(2, '0')
  return `${p(dt.getDate())}/${p(dt.getMonth() + 1)}/${dt.getFullYear()} ${p(dt.getHours())}:${p(dt.getMinutes())}:${p(dt.getSeconds())}`
}

const MarketBlock = ({ market, title }) => (
  <div className="col-lg-4">
    <div className="market-analysis-content-detail">
      <table className="table">
        <thead>
          <tr>
            <th colSpan="2">{market.name}</th>
          </tr>
        </thead>
        <tbody>
          {orderRows(market.rows || [], title).map((row) => (
            <tr key={row.label}>
              <td>{row.label}</td>
              <td className="text-right">{fmtVal(row.value)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)

const MatchBlock = ({ match }) => {
  const title = match.match_title
  // d99 ka game-details route /admin ke bina hai — dexch wala path yahan 404 dega
  const link = match.sport_id && match.eventid
    ? `/game-details/${encodeURIComponent(match.sport_id)}/${encodeURIComponent(match.eventid)}`
    : null
  return (
    <div className="market-analysis-container">
      <div className="market-analysis-title">
        <div>
          {link
            ? <Link to={link} className="ma-link">{title}</Link>
            : <span className="ma-link">{title}</span>}
        </div>
        {' '}
        <div>{fmtDate(match.event_date)}</div>
      </div>
      <div className="market-analysis-content">
        <div className="row row5">
          {(match.markets || []).map((market) => (
            <MarketBlock key={market.name} market={market} title={title} />
          ))}
        </div>
      </div>
    </div>
  )
}

function MarketAnalysis() {
  const { matches, search, setSearch, loading, error, refresh } = useMarketAnalysis()

  return (
    <Layout title="Market Analysis - Diamond Admin">
      {/* Full Page Diamond Loader */}
      {loading && (
        <div style={{
          display: 'block',
          position: 'fixed',
          zIndex: 9999,
          backgroundImage: `url(${loaderGif})`,
          backgroundColor: '#666',
          opacity: 0.4,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          left: 0,
          bottom: 0,
          right: 0,
          top: 0,
          backgroundSize: '100px 100px'
        }} />
      )}
      <div className="listing-grid">
        <div className="market-analysis">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">
                  Market Analysis
                  <a
                    href="#"
                    title="Refresh Data"
                    className="text-dark pl-2"
                    onClick={(e) => {
                      e.preventDefault()
                      refresh()
                    }}
                  >
                    <i className={`fa fa-sync${loading ? ' fa-spin' : ''}`}></i>
                  </a>
                </h4>
                <div className="page-title-right">
                  <input
                    type="text"
                    name="searchMarktetText"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search Event"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          {error ? (
            <div className="market-analysis-container">
              <div className="market-analysis-content p-4 text-center text-danger">
                <i className="fas fa-exclamation-circle fa-2x" />
                <p className="mt-2 mb-0">{error}</p>
              </div>
            </div>
          ) : (
            // reference: outer container hamesha render hota hai, events na ho to khali
            <div className="market-analysis-container">
              {matches.map((match) => (
                <MatchBlock key={match.eventid || match.match_title} match={match} />
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default MarketAnalysis
